import { FormFieldTypes } from "../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../components/forms/libs/data/ValidationTypes";


const initState = {
  emailAddress: "",
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};

export const changePasswordFormConfig = {
  name: "User Details",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic User Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row row-gap"></div>,
      fields: [
        {
          id: "emailAddress",
          label: "Email Address",
          Field_Name: "email address",
          fieldType: FormFieldTypes.INPUT,
          dataField: "emailAddress",
          fieldSetting: {
            placeholder: "Please enter email address",
             allowSpace: true,
            isDisable: true,
          },
          validation: [{ type: validationTypes.REQUIRE }, { type: validationTypes.EMAIL }],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        
        {
          id: "oldPassword",
          label: "Current Password",
          Field_Name: "currentPassword",
          fieldType: FormFieldTypes.PASSWORD,
          dataField: "oldPassword",
          fieldSetting: {
            placeholder: "Enter current password",
             allowSpace: true,
            isDisable: false,
          },
          validation: [
            { type: validationTypes.REQUIRE },
            { type: validationTypes.PASSWORD },
          ],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "newPassword",
          label: "New Password",
          Field_Name: "newPassword",
          fieldType: FormFieldTypes.PASSWORD,
          dataField: "newPassword",
          fieldSetting: {
            placeholder: "Enter new password",
             allowSpace: true,
            isDisable: false,
          },
          validation: [
            { type: validationTypes.REQUIRE },
            { type: validationTypes.PASSWORD },
          ],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "confirmPassword",
          label: "Confirm Password",
          Field_Name: "confirm password",
          fieldType: FormFieldTypes.PASSWORD,
          dataField: "confirmPassword",
          fieldSetting: {
            placeholder: "Enter confirm password",
             allowSpace: true,
            isDisable: false,
          },
          validation: [
            { type: validationTypes.REQUIRE },
            { type: validationTypes.PASSWORD },
            { type: validationTypes.COMPARE, compareEle: "newPassword" },
          ],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        

      ],
    },
  ],
};
